import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Wrench } from 'lucide-react'
import { useAuth } from '../../contexts/AuthProvider'
import { devService } from '../../services/integracionService'
import { UsuarioDev } from '../../types/integracion'
import { mensajeDeError } from '../../utils/errores'
import { Alerta, Boton, Campo, Entrada } from '../kit'

/**
 * Solo en desarrollo (el backend lo apaga en producción): entrar como cualquier
 * usuario sin pasar por el portal, que en localhost suele no estar configurado.
 */
export function EntrarComoDev({ destino }: { destino: string }) {
  const { entrar } = useAuth()
  const navigate = useNavigate()
  const [q, setQ] = useState('')
  const [usuarios, setUsuarios] = useState<UsuarioDev[]>([])
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const t = setTimeout(() => devService.usuarios(q).then(setUsuarios).catch(() => setUsuarios([])), 250)
    return () => clearTimeout(t)
  }, [q])

  const como = async (datos: { username: string } | { admin: true }) => {
    try {
      entrar((await devService.entrarComo(datos)).user)
      navigate(destino, { replace: true })
    } catch (err) {
      setError(mensajeDeError(err))
    }
  }

  return (
    <div className="pila">
      <Alerta tipo="info" titulo="Modo desarrollo">Entra sin credenciales. En producción esta sección no existe.</Alerta>
      {error && <Alerta tipo="error">{error}</Alerta>}
      <Boton variante="outlined" icono={Wrench} onClick={() => como({ admin: true })}>
        Entrar como administrador (dev)
      </Boton>
      <Campo etiqueta="O como un usuario existente">
        <Entrada type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por usuario o nombre" />
      </Campo>
      {usuarios.length > 0 && (
        <ul className="lista-simple">
          {usuarios.map((u) => (
            <li key={u.username}>
              <button type="button" className="dcc-btn dcc-btn--sm dcc-btn--text" onClick={() => como({ username: u.username })}>
                {u.nombre} <span className="texto-secundario">({u.username}{u.es_staff ? ', staff' : ''})</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
